import ReactDOM from "react-dom"
import HumanMusic from "./human-music/human-music"
import "./styles/index.css"

ReactDOM.render(<HumanMusic />, document.getElementById("root"))
